import Typography from "@mui/material/Typography";

import ConfirmationModal, {
  ConfirmationModalProps,
} from "@rui/ConfirmationModal";
import { Bold } from "@rui/styles";

interface RequireEditPermissionsConfirmationModalProps
  extends Omit<ConfirmationModalProps, "children"> {
  calendarDisplayName: string;
}

const RequireEditPermissionsConfirmationModal = ({
  calendarDisplayName,
  open,
  onClose,
  onConfirm,
}: RequireEditPermissionsConfirmationModalProps) => {
  return (
    <ConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Heads up!"
      confirmProps={{ label: "Yes, continue" }}
      cancelProps={{ label: "Not now" }}
    >
      <Typography variant="bodyPrimaryReg">
        To change this setting, Read needs to be able to edit your{" "}
        <Bold>{calendarDisplayName}</Bold> calendar. Do you want to grant edit
        permission?
      </Typography>
    </ConfirmationModal>
  );
};

export default RequireEditPermissionsConfirmationModal;
